import React from 'react';
import { MOTIVOS } from '../data/license';
import { MARK } from '../constants';

/**
 * Tela de bloqueio por licença.
 *
 * Diz o motivo e o que fazer. E diz, com todas as letras, que os lançamentos
 * pendentes continuam guardados — porque a primeira reação de quem é barrado
 * em campo é achar que perdeu o trabalho do dia. Nada é apagado aqui: a fila
 * segue no aparelho e sobe assim que a licença voltar.
 */
const LicencaBloqueada = ({ motivo, onTentarNovamente, verificando }) => (
  <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
    <div className="max-w-md w-full bg-white rounded-lg border border-slate-200 shadow-sm p-8">
      <div className="text-3xl mb-3" aria-hidden="true">{MARK.WARN}</div>

      <h1 className="text-lg font-semibold text-slate-900 mb-2">
        Aplicativo não liberado
      </h1>

      <p className="text-sm text-slate-600 mb-4 leading-relaxed">
        {MOTIVOS[motivo] || 'Não foi possível confirmar a liberação deste computador.'}
      </p>

      <div className="bg-slate-50 border border-slate-200 rounded-md p-3 mb-5">
        <p className="text-xs text-slate-600 leading-relaxed">
          <strong className="text-slate-800">Seus dados estão seguros.</strong>{' '}
          Nada foi apagado. O que você lançou sem internet continua guardado neste
          computador e sobe assim que o acesso for liberado.
        </p>
      </div>

      <button
        onClick={onTentarNovamente}
        disabled={verificando}
        className="w-full bg-blue-600 text-white py-2.5 rounded-md text-sm font-medium hover:bg-blue-700 disabled:opacity-50 transition-colors"
      >
        {verificando ? 'Verificando…' : 'Tentar novamente'}
      </button>

      <p className="text-xs text-slate-500 mt-4 text-center">
        Conecte-se à internet e tente de novo.
      </p>
    </div>
  </div>
);

export default LicencaBloqueada;
